import {
  AdminSVG,
  CloudMoveSVG,
  HeadphonesSVG,
} from '@sbercloud/uikit-product-icons';
import {
  SectionPersonalManager,
  SectionPersonalManagerProps,
} from '@sbercloud/uikit-product-site-section';
import React from 'react';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { ClickAnalyticsType } from 'src/types';

import { useAnalytics } from '../../hooks/useAnalytics';

const MOCK = {
  title: 'Больше чем просто поддержка',
  description:
    'Полное сопровождение для решения ваших задач и понятный бизнес-результат',
  manager: {
    title: 'Индивидуальный подход к каждому клиенту',
    text: 'Проведем бесплатную консультацию по вашему проекту, ответим на вопросы и подберем лучшие решения.',
    img: 'https://cdn.cloud.ru/backend/images/personal_manager.png',
  },
  card: {
    title: 'Круглосуточно на связи',
    text: 'Бесплатная техподдержка 24/7, на связи всегда реальные люди.',
  },
  benefits: [
    {
      title: '1 400+ экспертов в области IT, кибербезопасности и AI',
      image: AdminSVG,
    },
    {
      title:
        'Проверенные методологии и лучшие практики бесшовной миграции в облако',
      image: CloudMoveSVG,
    },
    {
      title: 'Персональный менеджер для сопровождения ваших задач',
      image: HeadphonesSVG,
    },
  ],
};

type BenefitType = {
  title: string;
  image?: JSX.Element;
};
interface ButtonProps {
  title: string;
  analyticsOptions: ClickAnalyticsType;
  link?: string;
  onClick?: () => void;
}
type CardType = {
  title: string;
  text?: string;
};

type ManagerCardType = {
  title?: string;
  text?: string;
  img?: string;
};

type ClassNamesType = {
  root?: string;
  wrapper?: string;
  header?: string;
  body?: string;
  manager?: string;
  content?: string;
  button?: string;
  img?: string;
  card?: string;
  benefits?: string;
};
export interface PersonalManagerProps {
  id?: string;
  title?: string;
  description?: string;
  manager?: ManagerCardType;
  card?: CardType;
  benefits?: BenefitType[];
  classNames?: ClassNamesType;

  button?: ButtonProps;
  withoutBenefits?: boolean;
}

export const PersonalManager = ({
  id,
  title,
  description,
  manager,
  card,
  benefits,
  button,
  withoutBenefits,
}: PersonalManagerProps) => {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();
  const curTitle = title ?? MOCK.title;
  const curDescription = description || MOCK.description;

  const curManager = {
    title: manager?.title ?? MOCK.manager.title,
    text: manager?.text || MOCK.manager.text,
    img: manager?.img || MOCK.manager.img,
  } satisfies SectionPersonalManagerProps['manager'];

  const curCard = {
    title: card?.title ?? MOCK.card.title,
    text: card?.text || MOCK.card.text,
  } satisfies SectionPersonalManagerProps['card'];

  const benefitsCards: SectionPersonalManagerProps['benefits'] = (
    benefits || MOCK.benefits
  )?.map((benefit) => ({
    title: benefit.title,
    icon: benefit.image,
  }));

  return (
    <SectionPersonalManager
      id={id}
      title={curTitle}
      description={curDescription}
      manager={curManager}
      card={curCard}
      onGetConsultationClick={() => {
        if (button) {
          clickAnalytics(button.analyticsOptions);
          button.onClick?.();
        }
      }}
      benefits={benefitsCards}
      withoutBenefits={withoutBenefits}
      layoutType={layoutType}
      data-test-id="section-personal-manager"
      data-attribute="no_search_index"
    />
  );
};
